<template>
  <v-dialog v-model="showDialog" persistent width="400" height="600">
    <v-card class="pa-3">
      <div>
        <div class="md-subheader-no-spacing mb-3">Order Placed!</div>
        <div class="md-body-no-spacing mb-3">
          Would you like to add another order?
        </div>
      </div>
      <div class="d-flex align-center">
        <v-spacer />

        <v-btn @click="goBack">
          <div style="color: #119ae9">No Thanks</div></v-btn
        >

        <v-btn @click="addAnotherOrder">
          <div style="color: #119ae9">Yes</div></v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      showDialog: false,
    };
  },

  methods: {
    show() {
      this.showDialog = true;
    },
    toggleDialog() {
      this.showDialog = !this.showDialog;
    },
    goBack() {
      this.$emit("goBack");
      this.showDialog = false;
    },
    addAnotherOrder() {
      this.$emit("addAnotherOrder");
      this.showDialog = false;
    },
  },
};
</script>

<style scoped>
</style>
